import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import UserModule from "@/store/modules/user.module";
import { ChangePasswordModel } from "../../../store/models/users/changePassword";
import { AuthModule } from "@/store/modules/auth.module";
import { SettingModule } from "@/store/modules/settings.module";
import { toaster } from "@/utilities/toaster";
import { SecurityUserModel } from "@/store/models/users/securityUsers";
import TwoFactorConfigComponent from "./components/TwoFactorConfigComponent.vue";
// import CalendarIntegrationComponent from "./components/CalendarIntegrationComponent.vue";
let Profile = /** @class */ (() => {
    let Profile = class Profile extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            //Data
            this.changePassword = new ChangePasswordModel();
            this.changePwdStep1 = true;
            this.changePwdStep2 = false;
            this.showCurrentPassword = false;
            this.showNewPassword = false;
            this.showConfirmPassword = false;
            this.userTimeZoneValue = this.userTimeZone;
            this.userDateFormatValue = this.userDateFormat;
            this.userDateFormatAndTimeZone = new SecurityUserModel();
            this.fullName = {};
            this.email = "";
            this.title = "Profile";
            this.items = [
                {
                    text: "Profile",
                    active: true,
                },
            ];
            this.activeMenu = null;
            this.profileImage = null;
            this.menuProfile = [
                {
                    id: 1,
                    menuName: "Account",
                    iconName: "bx-user",
                },
                {
                    id: 2,
                    menuName: "Change Password",
                    iconName: "bx-key",
                },
                {
                    id: 3,
                    menuName: "Two Factor Authentication",
                    iconName: "bx-shield",
                },
                {
                    id: 4,
                    menuName: "Settings",
                    iconName: "bx-cog",
                },
            ];
        }
        data() {
            return {
                fullName: AuthModule.fullName,
                email: AuthModule.email,
            };
        }
        showChangePwd() {
            this.changePwdStep2 = !this.changePwdStep2;
            this.changePwdStep1 = !this.changePwdStep1;
            this.changePassword.oldPassword = "";
            this.changePassword.newPassword = "";
            this.changePassword.newConfirmPassword = "";
            this.reset("updatePasswordObserver");
        }
        toggleCurrentShow() {
            this.showCurrentPassword = !this.showCurrentPassword;
        }
        toggleNewShow() {
            this.showNewPassword = !this.showNewPassword;
        }
        toggleConfirmShow() {
            this.showConfirmPassword = !this.showConfirmPassword;
        }
        UpdatePassword() {
            this.validate("updatePasswordObserver").then((response) => {
                if (response) {
                    UserModule.UpdatePassword(this.changePassword)
                        .then((response) => {
                        console.log(this.changePassword);
                        if (response.successMessages.length > 0) {
                            toaster.ShowSuccess(`Your password has been changed successfully.`);
                            this.changePwdStep2 = !this.changePwdStep2;
                            this.changePwdStep1 = !this.changePwdStep1;
                        }
                        else {
                            alert(response.warningMessages.toString());
                        }
                    })
                        .catch((err) => console.log(err));
                }
            });
        }
        fileSelected2(e) {
            var newFiles = e.target.files || e.dataTransfer.files;
            if (!newFiles.length)
                return;
            this.profileImage = newFiles[0];
            if (this.ImageValidator(this.profileImage)) {
                this.uploadProfilePicture();
            }
            else {
                toaster.ShowError("Please upload an image with the file format as .jpg, .png or .svg.");
            }
        }
        uploadProfilePicture() {
            let formData = new FormData();
            formData.append("file", this.profileImage);
            UserModule.UploadProfilePicture(formData).then((res) => {
                SettingModule.userProfile.profileImageUrl = res.imageUrl;
            });
        }
        changeDateFormatAndTimeZone() {
            this.userDateFormatAndTimeZone.dateFormat = this.userDateFormatValue;
            this.userDateFormatAndTimeZone.timeZone = this.userTimeZoneValue;
            SettingModule.UpdateDateFormatAndTimeZone(this.userDateFormatAndTimeZone).then((response) => {
                if (response) {
                    toaster.ShowSuccess(response.successMessages[0]);
                }
            });
        }
        setMenu(menu) {
            this.activeMenu = menu;
            if (menu.id == 3) {
                this.$nextTick(() => {
                    let twoFactorConfig = this.$refs["twoFactorConfig"];
                    if (twoFactorConfig) {
                        twoFactorConfig.showModal();
                    }
                    else {
                        console.error("TwoFactorConfigComponent is not rendered.");
                    }
                });
            }
            // if (menu.id == 5) {
            //     this.$nextTick(() => {
            //         let calendarIntegration = this.$refs["calendarIntegration"] as CalendarIntegrationComponent;
            //         if (calendarIntegration) {
            //             // calendarIntegration.showModal();
            //         } else {
            //             console.error("TwoFactorConfigComponent is not rendered.");
            //         }
            //     });
            // }
        }
        get getProfilePicture() {
            return SettingModule.userProfile.profileImageUrl;
        }
        get userTimeZone() {
            return SettingModule.userTimeZone;
        }
        get userDateFormat() {
            return SettingModule.userDateFormat;
        }
        get userRole() {
            return SettingModule.userRole;
        }
        get timeZones() {
            return SettingModule.timeZones;
        }
        get DateFormats() {
            return SettingModule.dateFormats;
        }
        created() {
            this.activeMenu = this.menuProfile[0];
        }
    };
    Profile = __decorate([
        Component({
            name: "Profile",
            components: {
                Layout,
                PageHeader,
                TwoFactorConfigComponent,
            },
        })
    ], Profile);
    return Profile;
})();
export default Profile;
